const localeDateStringWithTime = (date) => {
    return `${(new Date(date)).toLocaleDateString("el-GR", { dateStyle: "long" })}, 
    ${new Date(date).toLocaleTimeString()}`
}

module.exports = { localeDateStringWithTime }